import { Attributes, DateUtils, Misc, Model, NeoModel, Rules, Validation, EnumHelper } from '@singularsystems/neo-core';

export default class PortfolioCriteria extends Model.CriteriaBase {
    static typeName = "PortfolioCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    public participantId: string | null = "";

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public balanceDate: Date | null = DateUtils.today();

    public separatedType: SeparatedType = SeparatedType.Exclude;

    public balanceFilter: BalanceFilterType = BalanceFilterType.AnyBalance;

    public incentiveSchemeIds: number[] = [];
    // Client only
}

export enum SeparatedType {
    Exclude = 1,
    Include = 2,
    SeparatedOnly = 3,
}

export enum BalanceFilterType {
  UnitBalance = 1,
    CashBalance = 2,
    AnyBalance = 3,
    ZeroBalance = 4,
}

EnumHelper.decorateEnum(BalanceFilterType, e => {
    e.describe(BalanceFilterType.UnitBalance, "Participants with Unit Balance", "Includes anyone with units, regardless of cash");
    e.describe(BalanceFilterType.CashBalance, "Participants with Cash Balance", "Includes anyone with cash, regardless of units");
    e.describe(BalanceFilterType.AnyBalance, "Participants with Any Balance (Units and or Cash)", "Includes anyone with either units or cash");
    e.describe(BalanceFilterType.ZeroBalance, "All Participants (Including zero balances)", "No filtering, shows all participants");
})